import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IState } from 'src/app/shared/store/root.reducer';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  footerCssClass: string;
  subscriptions: Subscription[] = [];
  versionNumber = 'DEVELOPMENT';
  today = Date.now();

  constructor(
    private store: Store<IState>,
  ) { }

  ngOnInit() {
    this.subscriptions.push(this.store.pipe(select((state: IState) => state.fullScreen))
      .subscribe(fullScreenState => {
        this.footerCssClass = fullScreenState.footerCssClass;
      }));

    this.store.pipe(select((state: IState) => state.app.version))
      .subscribe(version => {
         this.versionNumber = version;
      });
  }

  ngOnDestroy() {
    this.subscriptions.map(subscription => {
      subscription.unsubscribe();
    });
  }
}
